import React from "react";
import { combineReducers } from "redux";
import { sortBy, prop, clone, flatten, values, find } from "ramda";
import * as Actions from "./actions/recordingActions";
import { RECEIVE_AUTHORIZED } from "../authentication/actions/authenticationActions";
import { FETCH_CONTACT_GROUPS_SUCCESS, ADD_CONTACT_GROUP, UPDATE_CONTACT_GROUP } from "../contacts/actions/contactsActions";
import { disclosureWith } from "./models";

function contactGroups(state = {}, action) {
    let newState, contactGroup;

    switch (action.type) {
        case FETCH_CONTACT_GROUPS_SUCCESS:
            newState = clone(state);

            action.payload.forEach(contactGroup => {
                if (!newState[contactGroup.authorId]) {
                    newState[contactGroup.authorId] = []
                }

                newState[contactGroup.authorId] = newState[contactGroup.authorId].concat(contactGroup);
            });

            return newState;
        case ADD_CONTACT_GROUP:
            newState = clone(state);
            contactGroup = action.payload;

            if (!newState[contactGroup.authorId]) {
                newState[contactGroup.authorId] = [];
            }

            newState[contactGroup.authorId] = newState[contactGroup.authorId].concat(contactGroup);

            return newState;
        case UPDATE_CONTACT_GROUP:
            newState = clone(state);
            contactGroup = action.payload;

            newState[contactGroup.authorId] = newState[contactGroup.authorId].filter(group => group.id !== contactGroup.id)
                                                                             .concat(contactGroup);
            return newState;
        case RECEIVE_AUTHORIZED:
            const authorId = action.payload.userId;

            if (state[authorId] !== undefined) {
                return state;
            }

            newState = clone(state);
            newState[authorId] = [];

            return newState;
        default:
            return state;
    }
}

function recentDisclosures(state = {}, action) {
    let newState = clone(state);

    switch(action.type) {
        case Actions.SUBMIT_RECOMMENDATIONS_SUCCESS:
            const { id, instrumentSymbol, direction, disseminatedOn, disclosureUri } = action.payload;
            newState[id] = disclosureWith({
                instrumentSymbol,
                direction,
                disseminatedOn,
                disclosureUri,
                disclaimers: null,
                lastDifferingRecommendation: null
            });
            return newState;

        case Actions.REQUEST_FETCH_DISCLAIMERS:
            var { disclosureId } = action.payload;
            newState[disclosureId].numberOfAttempts++;
            return newState;
        case Actions.RECEIVE_DISCLAIMERS_RESULTS:
            var { disclosureId, disclaimers } = action.payload;
            newState[disclosureId].disclaimers = { success: disclaimers, errors: [] };
            newState[disclosureId].numberOfAttempts = 0;
            return newState;
        case Actions.LOAD_DISCLAIMERS_FAILED:
            var { disclosureId, errors } = action.payload;
            newState[disclosureId].disclaimers = { success: [], errors: [].concat(errors) };
            newState[disclosureId].numberOfAttempts = 0;
            return newState;

        case Actions.REQUEST_FETCH_LAST_DIFFERING_RECOMMENDATION:
            var { disclosureId } = action.payload;
            newState[disclosureId].numberOfAttemptsForLastDifferingRecommendation++;
            return newState;
        case Actions.RECEIVE_LAST_DIFFERING_RECOMMENDATION_RESULT:
            var { disclosureId, recommendation } = action.payload;
            newState[disclosureId].lastDifferingRecommendation = { success: recommendation, errors: [] };
            newState[disclosureId].numberOfAttemptsForLastDifferingRecommendation = 0;
            return newState;
        case Actions.LOAD_LAST_DIFFERING_RECOMMENDATION_FAILED:
            var { disclosureId, errors } = action.payload;
            newState[disclosureId].lastDifferingRecommendation = { success: null, errors: [].concat(errors) };
            newState[disclosureId].numberOfAttemptsForLastDifferingRecommendation = 0;
            return newState;

        default:
            return state;
    }
}

export function getContactGroup({ recorder: { contactGroups }}, contactGroupId) {
    return find(g => g.id === contactGroupId, flatten(values(contactGroups)));
}

export function getRecentDisclosures({ recorder: { recentDisclosures }}) {
    const toArrayOfDisclosures = (acc, key) => {
        acc.push(Object.assign({ id: key }, recentDisclosures[key]));
        return acc;
    };

    const disclosures = Object.keys(recentDisclosures).reduce(toArrayOfDisclosures, []);

    return sortBy(prop("disseminatedOn"), disclosures).reverse();
}

export function recorderReduxFormPlugin(state, action) {
    switch (action.type) {
        case "redux-form/CHANGE":
            if (action.field.endsWith(".searchUniverse")) {
                const recommendationFieldIndex = action.field.match(/recommendations\[(\d+)\]/)[1];
                const newState = clone(state);
                newState.recommendations[recommendationFieldIndex].legs.forEach(leg => {
                    const instrumentField = leg.instrument;
                    instrumentField.value = Object.assign({}, instrumentField.initial);
                });

                return newState;
            }

            if (action.field === "contactGroups") {
                const newState = clone(state);
                newState.clients.value = state.clients.value.concat(action.value);

                return newState;
            }


            return state;
        default:
            return state;
    }
}

export default combineReducers({
    contactGroups,
    recentDisclosures
});



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/recordingReducers.js
 **/